import { createApp } from 'vue'
import App from './App.vue'
import './assets/tokens.css'
import './assets/base.css'
import router from './router/index'

import { Notify } from 'vant'
// Enable touch-event emulation for desktop browsers. Vant's interactive
// elements (e.g. Field clearable icon) bind `touchstart` only, so mouse clicks
// on desktop would otherwise be ignored. The emulator no-ops on real touch
// devices. Must be imported before createApp so it patches listeners eagerly.
import '@vant/touch-emulator'
// 引入文件
import VueClipBoard from 'vue-clipboard2'

router.beforeEach((to, from, next) => {
  const isWeixinBrowser = /micromessenger/i.test(navigator.userAgent)
  if (isWeixinBrowser) {
    if (to.path === '/fanghong') {
      next()
    } else {
      next('/fanghong')
    }
    return
  }

  const token = localStorage.getItem('tokenStr')
  const pageTitle = to.meta.title || to.meta.name
  if (pageTitle) {
    document.title = pageTitle
  }
  // meta.public === true means route does NOT require auth
  const isPublic = to.meta.public === true || to.meta.nacy === 'true'
  if (token || isPublic) {
    next()
  } else if (to.path === '/login') {
    next()
  } else {
    Notify({
      type: 'danger',
      message: '您还没有登录！',
      duration: 2000,
    })
    setTimeout(() => {
      next('/login')
    }, 2000)
  }
})

const app = createApp(App)
app.use(router).use(Notify).use(VueClipBoard)
app.mount('#app')
